export default {
  inforList_information: '09Web - Smart Portal information',
  inforList_information_list: '0901Web - Display infromation list',
  inforList_check_information: '0902Web - View information'
}
